import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Button,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  TextField 
} from '@material-ui/core';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';

import { toast, canAccess as canAccessUtil } from 'utils/helpers';
import { FormField2 as Field, CommonDialog } from 'components';

const filter = createFilterOptions();

const WorkReportManagerModal = ({ objectId, activeItem, onClose, }) => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState([]);
  const [manager, setManager] = useState('');

  const fetchEmployees = async () => {
    try {
      if (activeItem?.manager) setManager({ label: activeItem?.manager });
      const { data } = await api.get(`/accounts`);
      let managers = await api.post(`/work-reports/managers`, { estimateId: objectId });
      managers = managers.data;

      const employees = _.map(data, employee => {
        return employee?.user?.fullName;
      });

      const resultEmployees = _.uniq([ ...managers, ...employees ]);
      setEmployees(resultEmployees);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleSubmit = async (deleteManager = false) => {
    if (!manager) deleteManager = true;

    try {
      if (deleteManager) {
        setManager('');
        await api.post(`/estimates/${objectId}/items/${activeItem._id}/set-manager`, { manager: null });
      } else await api.post(`/estimates/${objectId}/items/${activeItem._id}/set-manager`, { manager: manager.label });
      toast(`${t('Darbų vadovas parinktas')}`, 'success');
    } catch (err) {
      console.error(err);
      window.alert(t('Įvyko klaida'));
    }

    onClose();
  }

  return (
    <CommonDialog
      visible
      onClose={onClose}
      maxWidth="xs"
      style={{ position: 'relative' }}
      actions={[
        <Button
          color="default"
          variant="text"
          onClick={() => onClose()}
        >
          Atšaukti
        </Button>,
        <Button
          color="default"
          variant="text"
          style={{ backgroundColor: "#f44336", height: 33, color: "#fff" }}
          onClick={() => handleSubmit(true)}
        >
          {t("Pašalinti")}
        </Button>,
        <Button
          color="primary"
          variant="contained"
          onClick={() => handleSubmit(false)}
        >
          Vykdyti
        </Button>
      ]}
    >
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan={2}>{t('Darbų vadovas')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell style={{ paddingTop: 0 }} >
                <Autocomplete
                  value={manager}
                  onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                      setManager({
                        label: newValue,
                      });
                    } else if (newValue && newValue.inputValue) {
                      // Create a new value from the user input
                      setManager({
                        label: newValue.inputValue,
                      });
                    } else {
                      setManager(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    // Suggest the creation of a new value
                    if (params.inputValue !== '') {
                      filtered.push({
                        inputValue: params.inputValue,
                        label: `${t('Pridėti')} "${params.inputValue}"`,
                      });
                    }

                    return filtered;
                  }}
                  options={_.map(employees, (employee) => ({ label: employee }))}
                  freeSolo
                  style={{ marginTop: 10 }}
                  getOptionLabel={(option) => option?.label?.toString() || option?.toString()}
                  renderInput={(params) => <TextField {...params} label={t("Darbų vadovas")} variant="outlined" />}
                  ListboxProps={{ style: { maxHeight: '15vh' } }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </CommonDialog>
  )
}

export default WorkReportManagerModal;